import React, { memo } from "react";

const Dashboard = () => {
  return <div>Dashboard</div>;
};

export default memo(Dashboard);
